var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-app',{attrs:{"md-mode":"fixed"}},[_c('md-app-drawer',{attrs:{"md-permanent":"full"}},[_c('user-sidebar',{ref:"sidebar"})],1),_c('md-app-content',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }